import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { BillingPaymentModel } from './billing-payment.model';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export class BillingPaymentListData extends ListData<BillingPaymentModel> {
    constructor(injector: Injector) {
        super(injector, true);

        this.ShowDelete = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('payment_information'),
                'paymentTypeName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: (row) => {
                        return row.isCreditCardInformation()
                            ? FiStateNames.Billing.Payment.CreditCardInformation.View
                            : FiStateNames.Billing.Payment.InvoiceInformation.View;
                    },
                    SrefParams: (data: BillingPaymentModel) => ({ BusinessUnitId: data.BusinessUnitId }),
                    mobileSubText: (data: BillingPaymentModel) => {
                        return data.BusinessUnitName + ': ' + this.getUnitTypeName(data);
                    },
                }),
            ),
        );

        this.addSpanPlainHeader(this.appTextService.get('common.unit'), 'BusinessUnitName');

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('unit_type'),
                'IsUnitHeadquarter',
                new ItemsListHeaderProperties('', true, ItemsListElementType.SpanPlain, {
                    GetClass: (data: BillingPaymentModel) => {
                        return data && data.IsUnitHeadquarter ? 'CcmListItemRed CcmListItemBold' : '';
                    },
                }),
                undefined,
                undefined,
                (data: BillingPaymentModel) => this.getUnitTypeName(data),
            ),
        );
    }

    private getUnitTypeName(data: BillingPaymentModel) {
        return this.appTextService.get(data.IsUnitHeadquarter ? 'head_quarter' : 'regular_unit');
    }
}
